// ファイルの文字コード　https://dev.classmethod.jp/articles/react-i-tried-sjis-conversion-support-with-csv-output-function-implemented-in-exceljs/

import React, { Component, useState, Fragment } from "react";
import ExcelJS from 'exceljs';
import encoding from "encoding-japanese";
import Cookies from 'js-cookie'

import Spreadsheet, { createEmptyMatrix } from "react-spreadsheet";

export default class Excel extends Component{
  state={
    //authObj:{},
    isOpen:false,
    table_data:[
      [{ value: "注文日"}, { value: "注文者名" }, { value: "JAN"}, { value: "数量"}, { value: "送り先〒"}, { value: "送り先住所"}, { value: "送り先名"}, { value: "送り先TEL"}],
      [{ value: ""}, { value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}],
      [{ value: ""}, { value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}],
      [{ value: ""}, { value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}],
      [{ value: ""}, { value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}],
      [{ value: ""}, { value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}],
      [{ value: ""}, { value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}],
      [{ value: ""}, { value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}],
      [{ value: ""}, { value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}]
    ],
    etoile_workbook:''
  }

  componentDidMount () {
  }

    




  render(){

      

    return (
      <div className="">
        <div className="">
          <>
            <Spreadsheet 
              data={this.state.table_data} 
              className="copy_data_table"
            />  
          </>
        </div>
      </div>
    )

  }

}